import React, { useState } from "react";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useNavigate } from "react-router";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";
import "./requests.scss";
import MDropdown from "../../components/MDropdown";
import FamilyComponent from "./components/family/family.component";
import NewsComponent from "./components/news/news.component";
import StoryComponent from "./components/stories/story.component";
import SessionDetails from "../../helpers/sessionDetails";
import { USER_TYPE } from "../../common/constants";
import HelplineComponent from "./components/helpline/helpline.component";

export default function Requests(props) {
  const [approvalTypes, setApprovalTypes] = useState([
    "Family",
    "News",
    "Stories",
    "Help request",
  ]);
  const [approvalType, setApprovalType] = useState("Family");

  React.useEffect(() => {}, []);

  const getApprovalView = () => {
    switch (approvalType) {
      case "Family":
        return <FamilyComponent approvalType={approvalType} />;
      case "News":
        return (
          <NewsComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );
      case "Stories":
        return (
          <StoryComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );
      case "Help request":
        return (
          <HelplineComponent
            approvalType={approvalType}
            onPageChange={(page, params) => props.onPageChange(page, params)}
          />
        );
    }
  };

  return (
    <Box className={"approvals-component d-flex flex-column p-md-3"}>
      {approvalTypes.length > 1 ? (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            width: "20%",
          }}
        >
          <MDropdown
            className={"input"}
            label=""
            name={"approval"}
            value={approvalType}
            onChange={(e) => setApprovalType(e.target.value)}
            options={approvalTypes}
          />
        </div>
      ) : null}

      {getApprovalView()}
    </Box>
  );
}
